import script from "./SetNewPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./SetNewPassword.vue?vue&type=script&setup=true&lang=js"

import "./SetNewPassword.vue?vue&type=style&index=0&id=485a4f56&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-485a4f56"]])

export default __exports__